import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import TableModule from '../TableModule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import apiClient from "../../axios";
import LoginNotification from "../Notifications/LoginNotification";
import Loader from "../Loader";


const AddWhatsAppModal = ({ isVisible, onClose, contractId }) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedModule, setSelectedModule] = useState();
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
    const [isLoginVisible, setIsLoginVisible] = useState(false);


    const fetchAllData = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/module_pack?productType=SUBSCRIPTIONS&moduleCode=WHATSAPP`);
            if (Array.isArray(response.data)) {
                setData(response.data);
                setTotalItems(response.data.length);
            } else {
                setData([response.data.results]);
                setTotalItems(1);
            }
        } catch (error) {
            console.error("Error al obtener los datos del servicio", error);
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAllData(currentPage);
    }, [currentPage, fetchAllData]); // Añadido 'fetchAllData' a las dependencias

    const handleRefresh = useCallback(() => {
        fetchAllData(currentPage);
    }, [fetchAllData, currentPage]);

    const handleSave = async () => {
        setLoading(true);
        const purchasedModules = data
            .filter(item => selectedModule === item.id)
            .map((item) => ({
                productId: item.moduleId,
                templateId: item.id,
                name: item.moduleName,
                extraUsers: 0
            }));
        try {
            const payload = {
                contractId,
                purchasedModules
            };
            const response = await apiClient.post('/orders', payload);
            if (response.status === 201) {
                const orderNumber = response.data.order.id;
                navigate(`/PurchaseSummary/${orderNumber}`);
            }

        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            }

        } finally {
            setLoading(false);
        }

    };

    const handleCheckboxChange = (id) => {
        setSelectedModule((prevSelected) => (prevSelected === id ? null : id));
    };

    const columns = [
        { title: "Nombre", key: "description" },
        { title: "Descripción", key: "description" },
        { title: "Meses", key: "extraSus" },
        { title: "Precio Módulo", key: "precioSus" },
        { title: "Seleccionar", key: "acciones" },
    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.id}</td>
            <td>{item.description}</td>
            <td>{item.paymentPeriod} meses</td>
            <td>${item.purchasePrice.toFixed(2)}</td>
            <td className="align-center">
                <input
                    type="checkbox"
                    checked={selectedModule === item.id}
                    onChange={() => handleCheckboxChange(item.id)}
                />
            </td>
        </>
    );

    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <div className="modal-content-module-body">
                        <h3 className="modal-title">PLANES DE WHATSAPP</h3>
                        <TableModule
                            title="Lista de PLANES"
                            rows={data}
                            columns={columns}
                            icon={faWhatsapp}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={handleRefresh}
                            loading={loading}
                            flagPagination={true}
                        />
                    </div>
                    <div className="basic-form-footer">
                        <button className="basic-custom-button" onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button" onClick={handleSave} disabled={!selectedModule} >
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
                {loading && <Loader />}
                <LoginNotification
                    message="Vuele a iniciar sesión"
                    isVisible={isLoginVisible}
                    onClose={() => setIsLoginVisible(false)}
                />
            </div>
        )
    );
};

export default AddWhatsAppModal;
